import React, { useEffect, useState, useRef } from "react";

/**
 * Expects selectedPayment from parent (the answer to 'payment'), e.g.:
 *   { type: 'insurance', provider: 'Aetna' }  OR  { type: 'self-pay' }
 * Submits one of: 'photos' | 'id' | 'skip'
 */
const InsuranceMethodQuestion = ({ onSubmit, onNext, initialValue, selectedPayment }) => {
    const [choice, setChoice] = useState(initialValue || "");
    const continueButtonRef = useRef(null);

    useEffect(() => {
        if (initialValue) setChoice(initialValue);
    }, [initialValue]);

    // Auto-scroll to continue button when component mounts
    useEffect(() => {
        const timer = setTimeout(() => {
            if (continueButtonRef.current) {
                continueButtonRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        }, 300);
        return () => clearTimeout(timer);
    }, []);

    const provider = selectedPayment?.type === "insurance" ? selectedPayment?.provider : null;
    const canSkip = provider !== "Blue Cross Blue Shield PPO"; // match your earlier rule

    const pick = (value) => {
        setChoice(value);
    };

    const handleContinue = () => {
        if (choice) {
            onSubmit(choice);
            onNext();
        }
    };

    return (
        <form onSubmit={(e) => e.preventDefault()} className="input-form">
            <div className="payment-options-container">
                <div className="payment-options">
                    <button
                        type="button"
                        className={`payment-button ${choice === "photos" ? "payment-button-selected" : ""}`}
                        onClick={() => pick("photos")}
                    >
                        Upload Photos
                    </button>

                    <button
                        type="button"
                        className={`payment-button ${choice === "id" ? "payment-button-selected" : ""}`}
                        onClick={() => pick("id")}
                    >
                        Enter Member ID
                    </button>

                    {canSkip && (
                        <button
                            type="button"
                            className={`payment-button ${choice === "skip" ? "payment-button-selected" : ""}`}
                            onClick={() => pick("skip")}
                        >
                            Add it later
                        </button>
                    )}
                </div>
                
                <button
                    ref={continueButtonRef}
                    type="button"
                    className="payment-submit-button"
                    onClick={handleContinue}
                    disabled={!choice}
                >
                    Continue
                </button>
            </div>
        </form>
    );
};

export default InsuranceMethodQuestion;
